var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":"Safety In Focus","src":require("@/assets/login_logo.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }